import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  return {
    id: id,
    elements: [
      {
        type: "line",
        id: "dymIxc6vnG",
        width: 5,
        left: 161.2041993637328,
        top: 4.713090609166969,
        start: [0, 0],
        end: [0, 220.150084835631],
        style: "solid",
        color: "#EDC573",
        points: ["", ""],
      },
      {
        type: "line",
        id: "BQJ6AuvHy-",
        width: 5,
        left: 283.58419936373275,
        top: 4.713090609166969,
        start: [0, 0],
        end: [0, 220.150084835631],
        style: "solid",
        color: "#EDC573",
        points: ["", ""],
      },
      {
        type: "shape",
        id: "_wQk9d2Z1S",
        width: 262.65,
        height: 120.35,
        left: 84.71629079769059,
        top: 227.21972074938137,
        viewBox: [262.65, 120.35],
        path: "M 15.04375 0 L 247.60625 0 Q 262.65 0 262.65 15.04375 L 262.65 105.30624999999999 Q 262.65 120.35 247.60625 120.35 L 15.04375 120.35 Q 0 120.35 0 105.30624999999999 L 0 15.04375 Q 0 0 15.04375 0 Z",
        fill: "#b92034",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#EDC573",
          width: 5,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 73.47px;"><span style="font-family: 微软雅黑;"><span style="color: rgba(246,246,246,1);">目录</span></span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 568.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
      },
    ],

    background,
  };
}
